import { z } from "zod";

export const AD_SUBURB_SCHEMA = z
  .object({
    postcode: z.string().min(1, "Postcode is required"),
    state: z.string().min(1, "State is required"),
    suburb: z.string().min(1, "Suburb is required"),
    stateCode: z.string().min(1, "State code is required"),
    description: z.string().min(1, "Description is required"),
    lat: z.number().min(-90).max(90).optional(),
    lon: z.number().min(-180).max(180).optional(),
    place_id: z.string(),
  })
  .refine(
    (suburb) => {
      if (
        !suburb.description &&
        !suburb.postcode &&
        !suburb.state &&
        !suburb.stateCode
      ) {
        return false;
      }
      return true;
    },
    {
      path: [],
      message:
        "Suburb is required.  You must select from the list. If no list appears, try another location.",
    },
  )
  .refine(
    (suburb) => {
      if (
        !suburb.description ||
        !suburb.postcode ||
        !suburb.state ||
        !suburb.stateCode
      ) {
        return false;
      }
      return true;
    },
    {
      path: [],
      message:
        "Sorry, we could not find a postcode for this suburb, please try another location.",
    },
  )
  .refine(
    (suburb) => {
      if (suburb.lat && (suburb.lat < -90 || suburb.lat > 90)) {
        return false;
      }
      return true;
    },
    { path: [], message: "Could not find coordinates for this location" },
  );

export type AdSuburbViewModel = z.infer<typeof AD_SUBURB_SCHEMA>;

export const AD_SUBURB_DEFAULTS: AdSuburbViewModel = {
  postcode: "",
  state: "",
  suburb: "",
  stateCode: "",
  description: "",
  place_id: "",
};
